import React, { Fragment } from 'react'
import AdditionalOrbitDetailsModal from './AdditionalOrbitDetailsModal';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import CustomToolTip from '../../../../../../CommonComponents/CustomToolTip';
import { ButtonGroup, Dropdown } from 'react-bootstrap';
import MissionService from '../../../../../../../service/MissionService';
import { toast } from 'react-toastify';
import { scenario_visualization } from '../../scenario_visualization/DataSources';
import useScenarioViewer from '../../hooks/useScenarioViewer';
dayjs.extend(utc)

interface AdditionaOrbitDetailsProps {
    additional_orbit_details: any;
    additional_orbits: any[];
    set_scenario_additional_orbits: (details: any[]) => void;
    set_scenario_additional_orbits_details: (details: any) => void;
    navigate_scenario: (details: string) => void;
    data_submited: string[];
    true_twin: Object;
    scenario_step?: string;
    isOpen: any;
    open_modal: (data) => void;
    close_modal: () => void;
    reset_additional_orbits: () => void;
    scenario_id: any;
    scenario_name: any;
    setAdditionalOrbits: (data: boolean) => void;
    loading: boolean | string;
    additionalOrbit: boolean;
    set_loading: (data: boolean | string) => void;
    scenarioData: any;
    get_scenario_data: (data: any) => void;
}

const AdditionaOrbitDetails: React.FC<AdditionaOrbitDetailsProps> = ({ additional_orbit_details, additional_orbits, set_scenario_additional_orbits,
    get_scenario_data, navigate_scenario, set_scenario_additional_orbits_details, data_submited, true_twin, scenario_step, isOpen, close_modal, open_modal, reset_additional_orbits, scenario_id, scenario_name, setAdditionalOrbits, additionalOrbit, loading, set_loading, scenarioData }) => {

    const { viewer } = useScenarioViewer()

    return (
        <Fragment>
            <div className="modalBoxShadowDiv">
                <button
                    onClick={() => {
                        if (data_submited?.includes('Additional_Orbits')) {
                            navigate_scenario("Additional_Orbits")
                        }
                    }}
                    className={`modalCheckboxDiv bg-transparent ${(data_submited?.length < 3 && scenario_step !== 'Additional_Orbits') ? "disabledBtn" : ''}`}
                >
                    <input type="checkbox" name="checkboxName" id="checkboxId" className="modalCheckbox" />
                    <div className={"modalDropDownIconBtn"}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d={scenario_step === 'Additional_Orbits' ? "M6.01108 8.97725L11.9879 15.0003L18.011 9.02344" : "M8.9775 17.9887L15.0005 12.0118L9.02368 5.98877"}
                                stroke="#F0F0F0"
                                strokeWidth="1.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </div>
                    <div className='flex-1 d-flex align-items-center justify-content-between gap-5'>
                        <div className={"modalCheckboxText modalWhiteSubHeader"}>
                            Additional Objects
                        </div>
                        {scenario_step === 'Additional_Orbits' &&
                            <CustomToolTip placement='top' title='Add Additional Orbital Details' >
                                <button className="additional_objects_btn me-6"
                                    onClick={(e) => {
                                        e.preventDefault()
                                        e.stopPropagation()
                                        reset_additional_orbits()
                                        open_modal(isOpen ? false : 'create')
                                    }}
                                >
                                    <i className='fe fe-plus opacity-50' />
                                </button>
                            </CustomToolTip>
                        }
                        {(scenario_step !== 'Additional_Orbits' && data_submited?.includes('Additional_Orbits')) && <img className="greenTickIcon" src={require("../../Images/GreenTickIcon.svg").default} />}
                    </div>
                </button>
            </div>
            {(scenario_step === 'Additional_Orbits' && additional_orbits?.length > 0) &&
                <div className={`d-flex flex-column gap-2 ps-6 pe-4 pt-3 ${loading && 'disable__components'}`}>
                    {additional_orbits?.length > 0 && additional_orbits.map((details, index) => (
                        <div key={index} className="additional_orbit_row">
                            <div className='d-flex align-items-center gap-2 w-90'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                    <path d="M9.45137 6.2486C10.2873 6.25003 11.0985 5.96554 11.7502 5.4424C11.8237 5.38408 11.8839 5.31076 11.9268 5.22735C11.9696 5.14394 11.9942 5.05235 11.9989 4.95869C12.0044 4.85944 11.9887 4.76016 11.9528 4.66748C11.9168 4.57479 11.8615 4.49084 11.7905 4.42122L9.92189 2.55353C10.184 2.29152 10.4596 2.01607 10.7218 1.74734C10.7756 1.70031 10.8226 1.65328 10.8764 1.59953C10.9363 1.53587 10.9696 1.45178 10.9696 1.36439C10.9696 1.27701 10.9363 1.19292 10.8764 1.12925C10.8451 1.09777 10.808 1.07278 10.767 1.05572C10.7261 1.03867 10.6821 1.02989 10.6378 1.02989C10.5934 1.02989 10.5495 1.03867 10.5085 1.05572C10.4676 1.07278 10.4304 1.09777 10.3991 1.12925C10.0765 1.44501 9.76729 1.76077 9.44464 2.07653L7.57599 0.208846C7.50542 0.139157 7.42127 0.0847097 7.32876 0.0488828C7.23626 0.0130559 7.13737 -0.00338571 7.03825 0.000578541C6.9447 0.00600657 6.85331 0.0309245 6.76997 0.0737327C6.68662 0.116541 6.61315 0.176294 6.55428 0.249156C5.99599 0.946173 5.71155 1.82295 5.75438 2.71477L4.77972 3.69565L3.21355 2.13028C3.15221 2.06652 3.07862 2.01579 2.99719 1.98113C2.91576 1.94648 2.82816 1.92862 2.73966 1.92862C2.65116 1.92862 2.56357 1.94648 2.48214 1.98113C2.40071 2.01579 2.32712 2.06652 2.26578 2.13028L0.195465 4.19952C0.0702708 4.32539 0 4.49567 0 4.67316C0 4.85065 0.0702708 5.02092 0.195465 5.1468L1.765 6.71216L1.48941 6.9809C1.15693 7.31457 0.970257 7.7663 0.970257 8.23722C0.970257 8.70814 1.15693 9.15987 1.48941 9.49354L2.5044 10.508C2.6689 10.674 2.86468 10.8058 3.08043 10.8957C3.29618 10.9856 3.52762 11.0319 3.76137 11.0319C3.99513 11.0319 4.22657 10.9856 4.44232 10.8957C4.65807 10.8058 4.85385 10.674 5.01835 10.508L5.28722 10.2393L6.8534 11.8046C6.97934 11.9298 7.1497 12 7.32728 12C7.50486 12 7.67523 11.9298 7.80117 11.8046L9.87148 9.72868C9.99667 9.60281 10.0669 9.43253 10.0669 9.25504C10.0669 9.07755 9.99667 8.90728 9.87148 8.7814L8.31202 7.22275L9.28668 6.24188C9.3414 6.24734 9.39639 6.24958 9.45137 6.2486ZM0.66599 4.67652L2.74302 2.60056L4.30248 4.16593L2.23553 6.23516L0.66599 4.67652ZM9.39759 9.2584L7.32728 11.3276L5.76111 9.76227L7.83142 7.69304L9.39759 9.2584ZM5.8821 3.54112C6.05212 4.15693 6.37947 4.71794 6.83201 5.16906C7.28454 5.62019 7.8467 5.94591 8.46326 6.11423L4.53774 10.0377C4.33081 10.2442 4.05038 10.3601 3.75801 10.3601C3.46564 10.3601 3.18521 10.2442 2.97829 10.0377L1.95657 9.01654C1.75003 8.80972 1.63402 8.52944 1.63402 8.23722C1.63402 7.945 1.75003 7.66472 1.95657 7.4579L5.8821 3.54112ZM7.30712 4.68995C6.77863 4.16863 6.46477 3.4683 6.42744 2.72708C6.39011 1.98587 6.63202 1.25758 7.10546 0.685846L9.20938 2.78867L11.32 4.89822L11.3335 4.91838C10.7517 5.38187 10.0194 5.61481 9.27665 5.57267C8.53386 5.53053 7.83267 5.21627 7.30712 4.68995Z" fill="#D2D2D2" />
                                </svg>
                                <span className='opacity-75 fs-16 w-100 text-truncate'>{details.name}</span>
                            </div>
                            <div className='additional_orbit_row_btn_container'>
                                <ButtonGroup size="sm" className="flex-nowrap mb-0">
                                    <div className="btn-list more-button">
                                        <Dropdown drop="end">
                                            <Dropdown.Toggle size="sm" variant="transparent">
                                                <i className="fe fe-more-vertical fs-20"></i>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item eventKey="0"
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        let additional_orbit_data = {
                                                            name: details.name,
                                                            altitude: details?.orbitParameters?.altitude,
                                                            inclination: details?.orbitParameters?.inclination,
                                                            eccentricity: details?.orbitParameters?.eccentricity,
                                                            RAAN: details?.orbitParameters?.RAAN,
                                                            AP: details?.orbitParameters?.AP,
                                                            TA: details?.orbitParameters?.TA
                                                        }
                                                        set_scenario_additional_orbits_details(additional_orbit_data)
                                                        open_modal('edit')
                                                    }}
                                                >
                                                    Edit
                                                </Dropdown.Item>
                                                <Dropdown.Item eventKey="1"
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        set_loading('Computing')
                                                        const filteredDetails = additional_orbits.filter(d => d.id !== details.id)
                                                        // const uniqueObjects = scenarioData?.externalAttachedOrbits.filter(obj => !filteredDetails.some(fd => fd.id === obj.id));
                                                        // set_loading(true)
                                                        // MissionService.deleteAdditionalObject(scenario_id, uniqueObjects?.[0]?.id).then((result) => {
                                                        //     if (result) {
                                                        //         set_scenario_additional_orbits(filteredDetails)
                                                        //         setAdditionalOrbits(!additionalOrbit)
                                                        //         set_loading(false)
                                                        //     }
                                                        // }).catch((err) => {
                                                        //     toast.error("Something went wrong!");
                                                        //     set_loading(false)
                                                        //     console.log(err)
                                                        // })
                                                        let body = {
                                                            ...scenarioData,
                                                            externalAttachedOrbits: filteredDetails,
                                                        }
                                                        MissionService.putScenario(scenario_id, body)?.then((response) => {
                                                            if (response?.data) {
                                                                get_scenario_data(scenario_id)
                                                                const satId = `Satellite/${details.name}`
                                                                scenario_visualization().remove_additional_satellite_packet(viewer, satId)
                                                            }
                                                        })?.catch((err) => {
                                                            toast.error("Getting error while posting external orbit details", { toastId: '0' });
                                                            set_loading(false)
                                                        })
                                                    }}
                                                >
                                                    Delete
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </ButtonGroup>
                            </div>
                        </div>
                    ))}
                </div>
            }

            <AdditionalOrbitDetailsModal
                additional_orbits={additional_orbits}
                set_scenario_additional_orbits={(data: any) => set_scenario_additional_orbits(data)}
                additional_orbit_details={additional_orbit_details}
                set_scenario_additional_orbits_details={(data: any) => set_scenario_additional_orbits_details(data)}
                close={close_modal}
                open={isOpen}
                scenario_id={scenario_id}
                scenario_name={scenario_name}
                setAdditionalOrbits={setAdditionalOrbits}
                additionalOrbit={additionalOrbit}
                set_loading={set_loading}
                get_scenario_data={get_scenario_data}
            />
        </Fragment>
    )
}

export default AdditionaOrbitDetails
